import {
  POST_CRONOGRAMACAL_AUTO, POST_CRONOGRAMA_AUTO, SET_MTOPREV, EDIT_CLIENTE, SET_SOL_CORR, LOADING_SOL_CORR, POST_SOLICITUD_MTO, POST_EDITPROGCAL, POST_EDITPROGMTO, SET_EQUIPOS_CAL, SET_CALIBRACIONES, SET_PROGCALS, SET_MTOSCORRECTIVOS, POST_MTOCORRECTIVO, SET_MTOSPREV, POST_PCAL, POST_MTOPREVENTIVO, SET_PROGMTOS, POST_PMTO, SET_EQUIPOS, SET_EQUIPO, POST_EQUIPO
  , SET_CLIENTE, SET_CLIENTES, SET_ERRORS, CLEAR_ERRORS, POST_CLIENTE
  , POST_CALIBRACION, LOADING_DATA, LOADING_UI, SET_EQUIPOS_MTO, LOADING_MTO, LOADING_CAL, LOADING_INDP, SET_INDICADORES_P, LOADING_DATA_CAL, SET_CALIBRACIONES_TABLA, POST_DOCLEGAL, SET_DOCSLEGAL, EDIT_DOCLEGAL, SET_OK, POST_EQUIPO_IA, LOADING_DATA_DATA, SET_EQUIPOIA, SET_OK_DATA, LOADING_DATA_UI, SET_ERRORS_DATA, CLEAR_EQUIPOS_IA,
  POST_RECOMENDACION_IA,
  SET_REPUESTOS,
  SET_CASOS_TECNO,
  SET_CASO_TECNO,
  POST_RUTA_APRENDIZAJE,
  STOP_LOADING_DATA,
  GET_CURSOS,
  GET_CURSOS_RECOMENDADOS,
  SET_TAREAS_CLIENTE,
  SET_INDICADORES_NEW,
  GET_ANALISIS_OBSOLESCENCIA_PRESTADOR,
  GET_ANALISIS_OBSOLESCENCIA_USUARIO,
  LOADING_REPUESTO,
  POST_DESCRIPCION_IA,
  SET_SERVICIOS_EQUIPOS
} from '../types';
import axios from 'axios';
import { getPerfil } from './useractions';
//Obtener todos los "twits"

import { apiV1, apiV2 } from '../../utils/api';



export const getClientes = () => dispatch => {
  dispatch({ type: LOADING_DATA });
  apiV1.get('/getclientes')
    .then(res => {
      dispatch({
        type: SET_CLIENTES,
        payload: res.data
      });
      dispatch(clearErrors());
    }).catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: []
      });
    })

}


export const deleteCliente = (clienteId) => (dispatch) => {
  dispatch({ type: LOADING_DATA });
  apiV1
    .delete(`/borrarcliente/${clienteId}`)
    .then(() => {
      dispatch(getClientes());
    })
    .catch((err) => console.log(err));
}

export const deleteEquipo = (clienteId, equipoId, history) => (dispatch) => {

  dispatch({ type: LOADING_DATA });


  apiV1
    .delete(`/borrarequiponew/${clienteId}/${equipoId}`)
    .then(() => {
      dispatch(clearErrors());
      history.push(`/dashboard/perfilcliente/${clienteId}/inventarioperfil`);
    })
    .catch((err) => console.log(err));

}

export const duplicarEquipo = (equipoId, clienteId) => (dispatch) => {
  dispatch({ type: LOADING_DATA });
  apiV2
    .post(`/duplicarequipo/${equipoId}`)
    .then((res) => {
      dispatch({
        type: SET_OK,
        payload: res.data
      });
      dispatch(clearErrors());
      dispatch(getEquipos(clienteId));
    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response ? err.response.data : null
      });
    });
};

export const getClientesPorIngeniero = (handleuser) => (dispatch) => {
  return apiV2.get(`/clientesporingeniero/${handleuser}`)
    .then(res => res.data)
    .catch(err => {
      console.error(err);
      return [];
    });
};

export const cambiarEquipoCliente = (equipoid, clienteidactual, clienteidfinal) => (dispatch) => {
  dispatch({ type: LOADING_UI });
  return apiV2.post(`/cambiarequipocliente/${equipoid}/${clienteidactual}/${clienteidfinal}`)
    .then((res) => {
      dispatch({ type: SET_OK, payload: res.data });
      dispatch(clearErrors());
      dispatch(getEquipos(clienteidactual)); 
      return res;
    })
    .catch((err) => {
      dispatch({ type: SET_ERRORS, payload: err.response ? err.response.data : { error: 'Error' } });
      throw err;
    });
};

export const getprogmtos = (equipoId) => dispatch => {
  dispatch({ type: LOADING_MTO });
  apiV1.get(`/getprogmto/${equipoId}`)
    .then(res => {
      dispatch({
        type: SET_PROGMTOS,
        payload: res.data
      });
      dispatch(clearErrors());
    }).catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: []
      });
    })

};

export const getprogcals = (equipoId) => dispatch => {
  dispatch({ type: LOADING_CAL });
  apiV2.get(`/getprogcal/${equipoId}`)
    .then(res => {
      dispatch({
        type: SET_PROGCALS,
        payload: res.data
      });
      dispatch(clearErrors());
    }).catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: []
      });
    })

};

export const getmtosprev = (equipoId) => dispatch => {
  dispatch({ type: LOADING_MTO });
  apiV2.get(`/mtospreventivos/equipo/${equipoId}`)
    .then(res => {
      dispatch({
        type: SET_MTOSPREV,
        payload: res.data
      });
      dispatch(clearErrors());
    }).catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: []
      });
    })

};

export const getmtoscorrectivos = (equipoId) => dispatch => {
  dispatch({ type: LOADING_MTO });
  apiV1.get(`/getmtoscorrectivos/${equipoId}`)
    .then(res => {
      dispatch({
        type: SET_MTOSCORRECTIVOS,
        payload: res.data
      });

      dispatch(clearErrors());

    }).catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: []
      });
    })

};


export const getCalibraciones = (equipoId) => dispatch => {
  dispatch({ type: LOADING_CAL });
  apiV2.get(`/getcalibraciones/${equipoId}`)
    .then(res => {
      dispatch({
        type: SET_CALIBRACIONES,
        payload: res.data
      });
      console.log("Obtuve Calibraciones")
      dispatch(clearErrors());

    }).catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: []
      });
      console.log("Algo salio Mal en Obtener Calibraciones")
    })

};

export const getCalibracionesCliente = (clienteId) => dispatch => {
  dispatch({ type: LOADING_DATA });
  apiV2.get(`/calibraciones/cliente/${clienteId}`)
    .then(res => {
      dispatch({
        type: SET_CALIBRACIONES,
        payload: res.data
      });
      console.log("Entre a get calibraciones cliente")
      dispatch(clearErrors());

    }).catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: []
      });
    })

};

export const getServiciosEquipos = (clienteId) => dispatch => {
  dispatch({ type: LOADING_DATA });
  apiV2.get(`/getServiciosEquipos/${clienteId}`)
    .then(res => {
      dispatch({
        type: SET_SERVICIOS_EQUIPOS,
        payload: res.data
      });

      dispatch(clearErrors());

    }).catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: []
      });
    })

};
export const subirReporteCalibracionTabla = (formData, equipoId, clienteId, calibracionId) => (dispatch) => {
  dispatch({ type: LOADING_DATA });


  apiV1.post(`/subirreportecalibracion/${clienteId}/${equipoId}/${calibracionId}`, formData)
    .then(() => {

      dispatch(getCalibracionesCliente(clienteId))



      //getcalibraciones 
    })
    .catch(err => console.log(err));


};

export const deleteDataCalibracionTabla = (calibracionid, clienteid) => (dispatch) => {
  dispatch({ type: LOADING_DATA });
  // /deletedatacal/:clienteid/:calibracionid
  apiV2
    .delete(`/calibraciones/${calibracionid}`)
    .then(() => {

      dispatch(getCalibracionesCliente(clienteid))
    })
    .catch((err) => console.log(err));


}

export const deleteCalibracion = (calibracionid, equipoid) => (dispatch) => {

  // /deletecalibracion/:clienteid/:equipoid/:reportefilename/:calibracionid
  apiV2
    .delete(`/calibraciones/${calibracionid}`)
    .then(() => {
      console.log('pdf borrado');
      dispatch(getCalibraciones(equipoid))
    })
    .catch((err) => console.log(err));
}




export const subirImagenCliente = (formData, clienteId) => (dispatch) => {
  dispatch({ type: LOADING_DATA });

  apiV2.post(`/subirimagen/${clienteId}`, formData)
    .then(() => {
      dispatch(getClientes());
    })
    .catch(err => console.log(err));
};


export const subirDocLegal = (formData, docId) => (dispatch) => {
  dispatch({ type: LOADING_DATA });

  apiV2.post(`/subirdoclegal/${docId}`, formData)
    .then((res) => {
      // Verificar si la respuesta tiene el mensaje 'aprobado'
      dispatch({
        type: SET_OK,
        payload: res.data
      });
      dispatch(clearErrors());
    })
    .catch((err) => {
      console.error('Error al subir documento:', err);

      // Enviar el error al estado para mostrarlo en UI
      dispatch({
        type: SET_ERRORS,
        payload: err.response ? err.response.data : { error: 'Error al conectar con el servidor' }
      });
    })
};

export const subirEquipos = (formData, clienteId) => (dispatch) => {
  dispatch({ type: LOADING_DATA });

  apiV1.post(`/subirequiposcsv/${clienteId}`, formData)
    .then(() => {
      dispatch(getCliente(clienteId));

      dispatch(getEquipos(clienteId));
      dispatch(getIndicadoresPrestador(clienteId));
    })
    .catch(err => console.log(err));
};


export const subirEquiposExcel = (formData, clienteId, handleUser) => (dispatch) => {
  dispatch({ type: LOADING_UI });
  apiV2.post(`/subirExcel/${handleUser}/${clienteId}`, formData)
    .then((res) => {
      dispatch({
        type: SET_OK,
        payload: res.data
      });
      console.log("Se ejecutó y ahora está en el getCliente");
    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    });
}

export const subirDocumento = (formData, clienteId, equipoId, handleUser) => (dispatch) => {
  dispatch({ type: LOADING_UI });
  apiV2.post(`/subirDocumento/${handleUser}/${clienteId}/${equipoId}`, formData)
    .then((res) => {
      dispatch({
        type: SET_OK,
        payload: res.data
      });
    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    });
};

export const subirPlantilla = (formData, clienteId, handleUser) => (dispatch) => {
  dispatch({ type: LOADING_UI });
  apiV1
    .post(`/subirPlantilla/${clienteId}`, formData)
    .then((res) => {
      dispatch({
        type: SET_OK,
        payload: res.data
      });
    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    });
};
export const subirImagenPerfil = (formData, handleuser) => (dispatch) => {
  dispatch({ type: LOADING_DATA });

  apiV1.post(`/subirimagenperfil/${handleuser}`, formData)
    .then(() => {
      dispatch(getPerfil());
    })
    .catch(err => console.log(err));
};

export const subirFirmaCliente = (formData, clienteid) => (dispatch) => {
  dispatch({ type: LOADING_DATA });

  apiV1.post(`/subirfirmacliente/${clienteid}`, formData)
    .then(() => {
      dispatch(getClientes());
    })
    .catch(err => console.log(err));
};

export const subirFirma = (formData, handleuser) => (dispatch) => {
  dispatch({ type: LOADING_DATA });

  apiV1.post(`/subirfirma/${handleuser}`, formData)
    .then(() => {
      dispatch(getPerfil());
    })
    .catch(err => console.log(err));
};




export const subirImagenEquipo = (formData, equipoId) => (dispatch) => {
  dispatch({ type: LOADING_DATA });

  apiV1.post(`/subirimagenequipo/${equipoId}`, formData)
    .then(() => {
      dispatch(getEquipo(equipoId));
    })
    .catch(err => console.log(err));
};


export const subirImagenEquipoInventario = (formData, equipoId, clienteId) => (dispatch) => {
  dispatch({ type: LOADING_DATA });

  apiV1.post(`/subirimagenequipo/${equipoId}`, formData)
    .then(() => {
      dispatch(getEquipos(clienteId));
    })
    .catch(err => console.log(err));
};

export const subirReporteCalibracion = (formData, equipoId, clienteId, calibracionId) => (dispatch) => {
  dispatch({ type: LOADING_DATA });

  apiV1.post(`/subirreportecalibracion/${clienteId}/${equipoId}/${calibracionId}`, formData)
    .then(() => {
      dispatch(getEquipo(equipoId));
      dispatch(getCalibraciones(equipoId));
      //getcalibraciones 
    })
    .catch(err => console.log(err));
};





export const subirReporte = (formData, equipoId) => (dispatch) => {
  dispatch({ type: LOADING_DATA });

  apiV1.post(`/subirreporte/${equipoId}`, formData)
    .then(() => {
      dispatch(getEquipo(equipoId));

    })
    .catch(err => console.log(err));
};



export const getCliente = (clienteId) => (dispatch) => {

  dispatch({ type: LOADING_DATA });

  apiV1.get(`/getcliente/${clienteId}`)
    .then(res => {
      dispatch({
        type: SET_CLIENTE,
        payload: res.data.credentials
      });
      dispatch(clearErrors());
    })
    .catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: null
      })
    })

}

export const getClienteTareas = (clienteId) => (dispatch) => {



  apiV1.get(`/getcliente/${clienteId}`)
    .then(res => {
      dispatch({
        type: SET_CLIENTE,
        payload: res.data.credentials
      });
      dispatch(clearErrors());
    })
    .catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: null
      })
    })

}



export const editCliente = (clienteDetails, clienteId) => (dispatch) => {

  dispatch({ type: LOADING_UI });
  apiV1.post(`/editcliente/${clienteId}`, clienteDetails)
    .then((res) => {
      dispatch({
        type: EDIT_CLIENTE,
        payload: res.data
      })
      //dispatch get programacion mtos
      dispatch(clearErrors());
      dispatch(getClientes());

    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    });


  dispatch(clearErrors());
  console.log('sali de edit');
};


export const eliminarDatosCliente = (clienteId) => (dispatch) => {
  apiV1
    .delete(`/deletecliente/${clienteId}`)
    .then(() => {
      dispatch(getClientes());
    })
    .catch((err) => console.log(err));
}

export const postCliente = (newCliente) => dispatch => {
  dispatch({ type: LOADING_UI });
  apiV1
    .post('/crearcliente', newCliente)
    .then((res) => {
      dispatch({
        type: SET_OK,
        payload: res.data,
      });
      dispatch(clearErrors());


    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    });

};

export const addTecnico = (newTecnico, clienteId) => dispatch => {
  dispatch({ type: LOADING_UI });
  apiV1
    .post(`/addtecnico/${clienteId}`, newTecnico)
    .then((res) => {
      dispatch({
        type: POST_CLIENTE,
        payload: res.data
      });
      dispatch(clearErrors());
      dispatch(getClientes());

    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    });

};

export const postCronogramaMtoAuto = (data, clienteId) => (dispatch) => {
  dispatch({ type: LOADING_UI });
  apiV2
    .post(`/programarmtoauto/${clienteId}`, data)
    .then((res) => {
      dispatch({
        type: SET_OK,
        payload: res.data
      });
      dispatch(clearErrors());

    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    });
}
export const postCronogramaCalAuto = (data, clienteId) => (dispatch) => {
  dispatch({ type: LOADING_UI });
  apiV2
    .post(`/cronogramacalauto/${clienteId}`, data)
    .then((res) => {
      dispatch({
        type: SET_OK,
        payload: res.data
      });
      dispatch(clearErrors());


    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    });
}

export const postDuplicarProgMtosRango = (data, clienteId, responsable) => (dispatch) => {
  dispatch({ type: LOADING_UI });
  apiV2
    .post(`/duplicarprogmtos/${clienteId}`, data)
    .then((res) => {
      dispatch({
        type: SET_OK,
        payload: res.data
      });
      dispatch(clearErrors());
      if(responsable) {
         dispatch(getListaMtosClienteFiltrado(clienteId, "01/01/1950", "01/01/2035", responsable));
      }
    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response ? err.response.data : { error: 'Error' }
      });
    });
}

export const postDuplicarProgCalRango = (data, clienteId, responsable) => (dispatch) => {
  dispatch({ type: LOADING_UI });
  apiV2
    .post(`/duplicarprogcal/${clienteId}`, data)
    .then((res) => {
      dispatch({
        type: SET_OK,
        payload: res.data
      });
      dispatch(clearErrors());
      if(responsable) {
         dispatch(getListaCalFiltrado(clienteId, "01/01/1950", "01/01/2035", responsable));
      }
    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response ? err.response.data : { error: 'Error' }
      });
    });
}

export const editClienteDetails = (clienteDetails, clienteId) => (dispatch) => {

  dispatch({ type: LOADING_UI });
  apiV1.post(`/detailscliente/${clienteId}`, clienteDetails)
    .then(() => {
      //dispatch get programacion mtos
      dispatch(getCliente(clienteId));

    })
    .catch(err => console.log(err));


  dispatch(clearErrors());
  console.log('sali de edit');
};


export const editEquipoDetails = (equipoDetails, equipoId) => (dispatch) => {

  dispatch({ type: LOADING_UI });
  apiV2.post(`/detailsequipo/${equipoId}`, equipoDetails)
    .then((res) => {
      dispatch({
        type: SET_OK,
        payload: res.data
      });


    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      })
    }
    );



  console.log('sali de edit');
};
//editEstado
export const editEstado = (estadoEquipo, equipoId) => (dispatch) => {

  dispatch({ type: LOADING_UI });
  apiV1.post(`/cambiarestado/${equipoId}`, estadoEquipo)
    .then(() => {
      //dispatch get programacion mtos
      dispatch(getEquipo(equipoId));

    })
    .catch(err => console.log(err));


  dispatch(clearErrors());
  console.log('sali de edit');
};


export const progMto = (newpmto, equipoId) => dispatch => {
  dispatch({ type: LOADING_UI });
  apiV2
    .post(`/programarmtoequipo/${equipoId}`, newpmto)
    .then((res) => {
      dispatch({
        type: SET_OK,
        payload: res.data
      });
      dispatch(clearErrors());

      dispatch(getprogmtos(equipoId));

    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    });

};

export const editProgMtoV2 = (newpmto, progid) => dispatch => {
  dispatch({ type: LOADING_UI });
  apiV2
    .post(`/editprogramarmto/${progid}`, newpmto)
    .then((res) => {
      dispatch({
        type: SET_OK,
        payload: res.data
      });
      dispatch(clearErrors());
    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    });

};

export const progCalibracion = (newprogcal, clienteId, equipoId) => dispatch => {
  dispatch({ type: LOADING_UI });
  apiV2
    .post(`/progrcalibracion/${clienteId}/${equipoId}`, newprogcal)
    .then((res) => {
      dispatch({
        type: SET_OK,
        payload: res.data
      });
      dispatch(clearErrors());

      //dispatch get programacion mtos
      dispatch(getprogcals(equipoId));


      //dispatch(getprogmtos(equipoId));

    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    });

};


export const postSolicitudMtoCorrectivo = (newSolicitud, equipoId) => dispatch => {
  dispatch({ type: LOADING_UI });
  apiV2
    .post(`/solicitarmtocorrectivov2/${equipoId}`, newSolicitud)
    .then((res) => {
      dispatch({
        type: POST_SOLICITUD_MTO,
        payload: res.data
      });
      dispatch({
        type: SET_OK,
        payload: {
          mensaje: 'Solicitud enviada exitosamente'
        }
      });
      dispatch(clearErrors());
      //dispatch(getEquipo(equipoId));
      //dispatch(getSolicitudesCorrectivos(equipoId));
    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    });
};

export const subirEvidenciaMtoCorrectivo = (formData, mtoid) => (dispatch) => {
  dispatch({ type: LOADING_UI });
  apiV1.post(`/subirevidenciamtocorrectivo/${mtoid}`, formData)
    .then((res) => {
      dispatch({
        type: SET_OK,
        payload: res.data
      })
      dispatch(clearErrors());

    })
    .catch(err => console.log(err));
};


export const postMtoCorrectivo = (newmtocorr, equipoid, clienteid) => (dispatch) => {
  dispatch({ type: LOADING_UI });
  apiV1
    .post(`/postmtocorrectivo/${clienteid}/${equipoid}`, newmtocorr)
    .then((res) => {
      dispatch({
        type: POST_MTOCORRECTIVO,
        payload: res.data
      });
      dispatch(clearErrors());

      //dispatch get programacion mtos
      //dispatch get mtos correctivos
      dispatch(getmtoscorrectivos(equipoid));
      dispatch(getSolicitudesCorrectivos(equipoid));
      dispatch(getEquipo(equipoid));
      //dispatch(getmtospreventivos(equipoId));

    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    });
}



export const postMtoCorrectivoConSolicitud = (newmtocorr, equipoid, clienteid, solicitudid) => (dispatch) => {
  dispatch({ type: LOADING_UI });

  // Comprobar si tenemos una firma digital o imagen que enviar
  if (newmtocorr.metodoRecepcion === 'firma' || newmtocorr.metodoRecepcion === 'imagen') {
    // Crear un objeto FormData para enviar archivos
    const formData = new FormData();

    // Agregar todos los campos del objeto newmtocorr al FormData
    Object.keys(newmtocorr).forEach(key => {
      // Ignorar el campo de imagen por ahora
      if (key !== 'imagenFirma') {
        // Para valores booleanos, convertirlos a cadenas
        if (typeof newmtocorr[key] === 'boolean') {
          formData.append(key, newmtocorr[key].toString());
        } else {
          formData.append(key, newmtocorr[key]);
        }
      }
    });

    // Convertir la cadena base64 a Blob y agregarla como archivo
    if (newmtocorr.imagenFirma) {
      // Extraer la parte de datos de la URL de datos
      const base64Data = newmtocorr.imagenFirma.split(',')[1];
      const blob = b64toBlob(base64Data, 'image/png');
      formData.append('file', blob, 'firma.png');
    }

    // Luego, enviar el FormData
    apiV2.post(`/postmtocorrectivowithsolicitudv2/${clienteid}/${equipoid}/${solicitudid}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .then((res) => {
        dispatch({
          type: POST_MTOCORRECTIVO,
          payload: res.data
        });
        dispatch({
          type: SET_OK,
          payload: {
            mensaje: 'Solicitud enviada exitosamente'
          }
        });
        dispatch(clearErrors());
      })
      .catch((err) => {
        dispatch({
          type: SET_ERRORS,
          payload: err.response.data
        });
      });
  } else {
    // Para métodos sin imágenes, hacer una solicitud JSON regular
    apiV2.post(`/postmtocorrectivowithsolicitudv2/${clienteid}/${equipoid}/${solicitudid}`, newmtocorr)
      .then((res) => {
        dispatch({
          type: POST_MTOCORRECTIVO,
          payload: res.data
        });
        dispatch({
          type: SET_OK,
          payload: {
            mensaje: 'Solicitud enviada exitosamente'
          }
        });
        dispatch(clearErrors());
      })
      .catch((err) => {
        dispatch({
          type: SET_ERRORS,
          payload: err.response.data
        });
      });
  }
};

// Función auxiliar para convertir base64 a Blob
function b64toBlob(b64Data, contentType = '', sliceSize = 512) {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);

    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
}



export const postMto = (newmtoprev, equipoid, clienteid, handleuser) => (dispatch) => {
  dispatch({ type: LOADING_UI });
  apiV1
    .post(`/postmtopreven/${clienteid}/${equipoid}/${handleuser}`, newmtoprev)
    .then((res) => {
      dispatch({
        type: SET_OK,
        payload: res.data
      });
      dispatch(clearErrors());

      //dispatch get programacion mtos


      dispatch(getmtosprev(equipoid));
      //dispatch(getmtospreventivos(equipoId));

    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    });
}

export const postMtoTabla = (newmtoprev, equipoid, clienteid, progid, handle) => (dispatch) => {
  console.log('Equipo Id' + equipoid);
  console.log('Cliente Id' + clienteid);
  console.log('Prog Id' + progid);
  console.log('Handle' + handle);
  dispatch({ type: LOADING_UI });
  apiV1
    .post(`/postmtopreven/${clienteid}/${equipoid}/${handle}/${progid}`, newmtoprev)
    .then((res) => {
      dispatch({
        type: SET_OK,
        payload: res.data
      });
      dispatch(clearErrors());

      //dispatch get programacion mtos
      //editprogmto 

      dispatch(editProgMtoTabla({ nuevoestado: 'Realizado' }, progid, clienteid))
      //***** */  
      //history.push(`/dashboard/perfilcliente/${clienteid}/cronomtoperfil`);     

      //dispatch(getmtospreventivos(equipoId));

    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    });
}

export const postMtoTablaV2 = (newmtoprev, equipoid, clienteid, progid, handle) => (dispatch) => {
  console.log('Equipo Id:', equipoid);
  console.log('Cliente Id:', clienteid);
  console.log('Prog Id:', progid);
  console.log('Handle:', handle);

  dispatch({ type: LOADING_UI });

  const usarFormData =
    newmtoprev.metodoRecepcion === 'firma' ||
    newmtoprev.metodoRecepcion === 'imagen' ||
    newmtoprev.archivoPDF ||
    (Array.isArray(newmtoprev.imagenesAdjuntas) && newmtoprev.imagenesAdjuntas.length > 0);

  let requestData;
  let headers = {};

  if (usarFormData) {
    requestData = new FormData();

    // 🔧 Añadir repuestos como campos individuales
    if (Array.isArray(newmtoprev.repuestos)) {
      newmtoprev.repuestos.forEach((valor, index) => {
        requestData.append(`repuesto${index + 1}`, valor);
      });
    }

    Object.keys(newmtoprev).forEach(key => {
      const value = newmtoprev[key];

      if (key === 'firmaDigital' && value?.startsWith('data:image')) {
        const blob = dataURItoBlob(value);
        requestData.append('firmaDigital', blob, 'firma.png');
      } else if (key === 'imagenFirma' && value?.startsWith('data:image')) {
        const blob = dataURItoBlob(value);
        requestData.append('imagenFirma', blob, 'imagenFirma.png');
      } else if (key === 'archivoPDF' && value instanceof File) {
        requestData.append('archivoPDF', value, value.name);
      } else if (key === 'imagenesAdjuntas' && Array.isArray(value)) {
        value.forEach((imgFile, index) => {
          if (imgFile instanceof File) {
            requestData.append(`imagenAdjunta${index + 1}`, imgFile, imgFile.name);
          }
        });
      } else if (
        key !== 'repuestos' && // ❌ omitimos repuestos porque ya los manejamos arriba
        (typeof value !== 'object' || value === null)
      ) {
        requestData.append(key, value);
      }
    });
  } else {
    requestData = newmtoprev;
    headers = {
      'Content-Type': 'application/json'
    };
  }

  const config = { headers };

  apiV2
    .post(`/postmtoprevenV3/${clienteid}/${equipoid}/${handle}/${progid}`, requestData, config)
    .then(res => {
      dispatch({ type: SET_OK, payload: res.data });
      dispatch(clearErrors());
      dispatch(editProgMtoTabla({ nuevoestado: 'Realizado' }, progid, clienteid));
    })
    .catch(err => {
      console.error('Error en postMtoTablaV3:', err);
      dispatch({
        type: SET_ERRORS,
        payload: err.response?.data || { error: 'Error al procesar la solicitud' }
      });
    });
};

/**
 * Helper to convert base64 to Blob for FormData
 */
function dataURItoBlob(dataURI) {
  // Convert base64/URLEncoded data component to raw binary data
  let byteString;
  if (dataURI.split(',')[0].indexOf('base64') >= 0) {
    byteString = atob(dataURI.split(',')[1]);
  } else {
    byteString = unescape(dataURI.split(',')[1]);
  }

  // Separate out the mime component
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  // Write the bytes of the string to a typed array
  const ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ia], { type: mimeString });
}

// aplana repuestos si vienen como array; si ya vienen como repuesto1..6, respeta
const flattenRepuestos = (src) => {
  const out = {};
  if (Array.isArray(src)) {
    src.forEach((v, i) => { out[`repuesto${i + 1}`] = v; });
  }
  return out;
};

export const editMtoTablaV2 = (editmtoprev, equipoid, clienteid, progid, handle) => (dispatch) => {
  dispatch({ type: LOADING_UI });

  // Decidir si usamos FormData (firma imagen/imagenFirma, archivo, imágenes nuevas)
  const usarFormData =
    editmtoprev.metodoRecepcion === 'firma' ||
    editmtoprev.metodoRecepcion === 'imagen' ||
    (editmtoprev.archivoPDF instanceof File) ||
    (Array.isArray(editmtoprev.imagenesAdjuntas) && editmtoprev.imagenesAdjuntas.length > 0);

  let requestData;
  let headers = {};

  if (usarFormData) {
    requestData = new FormData();

    // 1) Repuestos (si vienen como array)
    const repuestosAplanados = flattenRepuestos(editmtoprev.repuestos);
    Object.keys(repuestosAplanados).forEach(k => {
      requestData.append(k, repuestosAplanados[k]);
    });

    // 2) Campos primitivos
    Object.keys(editmtoprev).forEach((key) => {
      const value = editmtoprev[key];

      // firmaDigital: si viene en dataURL -> Blob; si viene como URL/str, la enviamos como string
      if (key === 'firmaDigital') {
        if (typeof value === 'string' && value.startsWith('data:image')) {
          requestData.append('firmaDigital', dataURItoBlob(value), 'firma.png');
        } else if (value) {
          requestData.append('firmaDigital', value);
        }
        return;
      }

      // imagenFirma: idem
      if (key === 'imagenFirma') {
        if (typeof value === 'string' && value.startsWith('data:image')) {
          requestData.append('imagenFirma', dataURItoBlob(value), 'imagenFirma.png');
        } else if (value) {
          requestData.append('imagenFirma', value);
        }
        return;
      }

      // archivoPDF nuevo
      if (key === 'archivoPDF') {
        if (value instanceof File) {
          requestData.append('archivoPDF', value, value.name);
        }
        return;
      }

      // nuevas imágenes
      if (key === 'imagenesAdjuntas') {
        if (Array.isArray(value)) {
          value.forEach((imgFile, i) => {
            if (imgFile instanceof File) {
              // Reutiliza la convención del post
              requestData.append(`imagenAdjunta${i + 1}`, imgFile, imgFile.name);
            }
          });
        }
        return;
      }

      // listas de control de edición
      if (key === 'imagenesRemotasEliminadas') {
        // pásalas como JSON para que el backend sepa qué keys borrar (p.ej. ["imagenAdjunta2"])
        requestData.append('imagenesRemotasEliminadas', JSON.stringify(value || []));
        return;
      }
      if (key === 'archivoPDFRemotoEliminado') {
        requestData.append('archivoPDFRemotoEliminado', Boolean(value));
        return;
      }

      // omitir propiedades “contenedoras” que ya tratamos arriba
      if (key === 'repuestos' || key === 'imagenesRemotas') return;

      // primitivos (string/number/bool) o fechas string
      if (typeof value !== 'object' || value === null) {
        requestData.append(key, value);
      }
    });

  } else {
    // JSON “puro”
    // une repuestos aplanados si vinieron como array
    const repuestosAplanados = flattenRepuestos(editmtoprev.repuestos);
    requestData = { ...editmtoprev, ...repuestosAplanados };
    delete requestData.repuestos; // para evitar duplicados

    headers = { 'Content-Type': 'application/json' };
  }

  const config = { headers };

  // ⚠️ Ajusta el endpoint/método a tu backend:
  // - si tu server no acepta PUT con FormData, usa POST a una ruta de edición
  // - aquí asumo editmtoprevenV3
  apiV2
    .put(`/editmtoprevenV3/${clienteid}/${equipoid}/${handle}/${progid}`, requestData, config)
    .then(res => {
      dispatch({ type: SET_OK, payload: res.data });
      dispatch(clearErrors());
      // refrescos que te interesen (ej.: getEquipo, o reload del reporte)
      // dispatch(getEquipo(equipoid));
    })
    .catch(err => {
      console.error('Error en editMtoTablaV2:', err);
      dispatch({
        type: SET_ERRORS,
        payload: err.response?.data || { error: 'Error al procesar la solicitud de edición' }
      });
    });
};

export const postCalibracion = (newcal, clienteid, equipoid, handleuser) => (dispatch) => {
  dispatch({ type: LOADING_UI });
  apiV2
    .post(`/calibraciones/${clienteid}/${equipoid}`, newcal)
    .then((res) => {
      dispatch({
        type: SET_OK,
        payload: res.data
      });
      dispatch(clearErrors());

      dispatch(getCalibraciones(equipoid));


    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    });

}

export const postCalibracionTabla = (newcal, clienteid, equipoid) => (dispatch) => {

  dispatch({ type: LOADING_UI });
  apiV2
    .post(`/calibraciones/${clienteid}/${equipoid}`, newcal)
    .then((res) => {
      dispatch({
        type: SET_OK,
        payload: res.data
      });
      //dispatch(getCalibraciones(equipoid));
      dispatch(clearErrors());
      // dispatch(editProgCalTabla({nuevoestado:'Realizado'},progid,clienteid))




    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    });

}

export const editProgMto = (nuevoestado, progid, equipoid) => (dispatch) => {
  apiV1
    .post(`/editprogmto/${progid}`, nuevoestado)
    .then((res) => {
      dispatch({
        type: POST_EDITPROGMTO,
        payload: res.data
      });
      dispatch(clearErrors());


      dispatch(getprogmtos(equipoid));

      //dispatch(getmtospreventivos(equipoId));

    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    });
}

export const editProgMtoTabla = (nuevoestado, progid, clienteid) => (dispatch) => {
  apiV1
    .post(`/editprogmto/${progid}`, nuevoestado)
    .then((res) => {
      dispatch({
        type: POST_EDITPROGMTO,
        payload: res.data
      });
      dispatch(clearErrors());

      //dispatch get programacion mtos




      //dispatch(getmtospreventivos(equipoId));

    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    });
}


export const deleteProgMto = (progid, equipoid) => (dispatch) => {
  dispatch({ type: LOADING_UI });
  apiV2
    .delete(`/progmtos/${progid}`)
    .then((res) => {
      dispatch({
        type: SET_OK,
        payload: res.data
      });
      dispatch(clearErrors());

      //dispatch get programacion mtos

      dispatch(getprogmtos(equipoid));
    })
    .catch((err) => console.log(err));
}



export const deleteProgMtoTabla = (progid) => (dispatch) => {
  apiV2
    .delete(`/progmtos/${progid}`)
    .then((res) => {
      dispatch({
        type: SET_OK,
        payload: res.data
      });
      dispatch(clearErrors());


    })
    .catch((err) => console.log(err));
}

export const editProgCal = (nuevoestado, progid, equipoid) => (dispatch) => {
  apiV1
    .post(`/editprogcal/${progid}`, nuevoestado)
    .then((res) => {
      dispatch({
        type: POST_EDITPROGCAL,
        payload: res.data
      });
      dispatch(clearErrors());

      //dispatch get programacion mtos


      dispatch(getprogcals(equipoid));


    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    });
}
export const editProgCalTabla = (nuevoestado, progid, clienteid) => (dispatch) => {
  apiV1
    .post(`/editprogcal/${progid}`, nuevoestado)
    .then((res) => {
      dispatch({
        type: POST_EDITPROGCAL,
        payload: res.data
      });
      dispatch(clearErrors());
      //dispatch get programacion mtos
      dispatch(getListaCalFiltrado(clienteid, "01/01/1950", "01/01/2035"))
    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    });
}
export const deleteProgCal = (progid, equipoid) => (dispatch) => {
  dispatch({ type: LOADING_UI });
  apiV2
    .delete(`/progcalibracion/${progid}`)
    .then((res) => {
      dispatch({
        type: SET_OK,
        payload: res.data
      });
      dispatch(clearErrors());
      dispatch(getprogcals(equipoid));


    })
    .catch((err) => console.log(err));
}

export const deleteProgCalTabla = (progid, clienteid) => (dispatch) => {
  dispatch({ type: LOADING_UI });
  apiV2
    .delete(`/progcalibracion/${progid}`)
    .then(() => {
      dispatch(clearErrors());
      //dispatch(getEquipo(equipoid));

      dispatch(getListaCalFiltrado(clienteid, "01/01/1950", "01/01/2035"));


    })
    .catch((err) => console.log(err));
}



export const deleteDataCalibracion = (dataCalibracion, equipoid, clienteid) => (dispatch) => {

  // /deletedatacal/:clienteid/:calibracionid
  apiV1
    .delete(`/deletedatacal/${clienteid}/${dataCalibracion.calibracionid}`)
    .then(() => {
      dispatch(getEquipo(equipoid));
      dispatch(getCalibraciones(equipoid));

    })
    .catch((err) => console.log(err));
}



export const deleteMtoPreventivo = (mtoid, equipoid) => (dispatch) => {
  dispatch({ type: LOADING_UI });

  apiV2
    .delete(`/mtospreventivos/${mtoid}`)
    .then((res) => {
      dispatch({
        type: SET_OK,
        payload: res.data
      });

      dispatch(getmtosprev(equipoid));
    })
    .catch((err) => console.log(err));
}

export const deleteMtoCorrectivo = (mtoid, equipoid) => (dispatch) => {
  apiV1
    .delete(`/deletemtocorrectivo/${mtoid}`)
    .then(() => {
      dispatch(getEquipo(equipoid));
      dispatch(getmtoscorrectivos(equipoid));
    })
    .catch((err) => console.log(err));
}







export const postEquipo = (newEquipo) => dispatch => {
  dispatch({ type: LOADING_UI });
  apiV2
    .post('/crearequipo', newEquipo)
    .then((res) => {
      dispatch({
        type: SET_OK,
        payload: res.data
      });
      dispatch(clearErrors());




      dispatch(getEquipos(newEquipo.idprestador));


    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    });

};

export const postNuevoEquipoIA = (newEquipo) => dispatch => {
  dispatch({ type: LOADING_DATA_UI });
  apiV2
    .post('/crearequipo', newEquipo)
    .then((res) => {
      dispatch({
        type: SET_OK_DATA,
        payload: res.data
      });
      dispatch(clearErrors());


    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS_DATA,
        payload: err.response.data
      });
    });

};

export const clearEquiposIA = () => dispatch => {
  dispatch({ type: CLEAR_EQUIPOS_IA });
}

export const postEquipoIA = (newEquipo) => dispatch => {
  dispatch({ type: LOADING_UI });
  apiV2
    .post('/semanticSearchEquipos', newEquipo)
    .then((res) => {
      dispatch({
        type: POST_EQUIPO_IA,
        payload: res.data
      });
      dispatch(clearErrors());
    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    });

};


export const getEquipoIA = (equipoId) => dispatch => {
  dispatch({ type: LOADING_DATA_DATA });
  apiV2.get(`/getequipoia/${equipoId}`)
    .then(res => {
      dispatch({
        type: SET_EQUIPOIA,
        payload: res.data
      });
      dispatch(clearErrors());
    }).catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: []
      });
    })
}

export const getEquipos = (clienteId) => dispatch => {
  dispatch({ type: LOADING_DATA });
  apiV1.get(`/getequipos/${clienteId}`)
    .then(res => {
      dispatch({
        type: SET_EQUIPOS,
        payload: res.data
      });
      dispatch(clearErrors());
    }).catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: []
      });
    })

}

export const getListaMtos = (clienteId) => dispatch => {
  dispatch({ type: LOADING_MTO });
  apiV1.get(`/getlistamtosnew/${clienteId}`)
    .then(res => {
      dispatch({
        type: SET_EQUIPOS_MTO,
        payload: res.data
      });
      dispatch(clearErrors());
    }).catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: []
      });
    })

}

export const getListaMtosClienteFiltrado = (clienteId, fechaInicio, fechaFin, responsable) => dispatch => {

  apiV2.get(`/getlistamtosfiltradocliente/${clienteId}`, {
    params: {
      fechaInicio: fechaInicio,
      fechaFin: fechaFin,
      responsable: responsable
    }
  })
    .then(res => {
      dispatch({
        type: SET_EQUIPOS_MTO,
        payload: res.data
      });
      dispatch(clearErrors());
    }).catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: []
      });

    })
}


export const getListaMtosMes = (clienteId, mes, year,) => dispatch => {
  dispatch({ type: LOADING_MTO });
  apiV1.get(`/getlistamtosmes/${clienteId}/mantenimiento/${mes}/${year}`)
    .then(res => {
      dispatch({
        type: SET_EQUIPOS_MTO,
        payload: res.data
      });
      dispatch(clearErrors());
    }).catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: []
      });
    })

}

export const getListaCal = (clienteId) => dispatch => {
  dispatch({ type: LOADING_CAL });
  apiV1.get(`/getlistacal/${clienteId}`)
    .then(res => {
      dispatch({
        type: SET_EQUIPOS_CAL,
        payload: res.data
      });
      dispatch(clearErrors());
    }).catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: []
      });
    })

}

export const getListaCalFiltrado = (clienteId, fechaInicio, fechaFin, responsable) => dispatch => {

  apiV2.get(`/progcalibracion/cliente/${clienteId}`, {
    params: {
      fechaInicio: fechaInicio,
      fechaFin: fechaFin,
      responsable: responsable
    }
  })
    .then(res => {
      dispatch({
        type: SET_EQUIPOS_CAL,
        payload: res.data
      });
      dispatch(clearErrors());
    }).catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: []
      });

    })
}

export const getListaCalMes = (clienteId, mes, year) => dispatch => {
  dispatch({ type: LOADING_CAL });
  apiV1.get(`/getlistacalmes/${clienteId}/calibracion/${mes}/${year}`)
    .then(res => {
      dispatch({
        type: SET_EQUIPOS_CAL,
        payload: res.data
      });
      dispatch(clearErrors());
    }).catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: []
      });
    })

}

export const getIndicadoresPrestador = (clienteId) => dispatch => {
  dispatch({ type: LOADING_INDP });
  apiV1.get(`/getindicadoresprestador/${clienteId}`)
    .then(res => {
      dispatch({
        type: SET_INDICADORES_P,
        payload: res.data
      });
      dispatch(clearErrors());
    }).catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: []
      });
    })

}


export const getIndicadoresPrestadorNew = (clienteId, year) => dispatch => {
  dispatch({ type: LOADING_INDP });
  apiV2.get(`/getIndicadoresCliente/${clienteId}/${year}`)
    .then(res => {
      dispatch({
        type: SET_INDICADORES_P,
        payload: res.data
      });
      dispatch(clearErrors());
    }).catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: []
      });
    })

}

export const getSolicitudesCorrectivos = (equipoId) => dispatch => {
  dispatch({ type: LOADING_SOL_CORR });
  apiV1.get(`/getsolicitudescorrectivo/${equipoId}`)
    .then(res => {
      dispatch({
        type: SET_SOL_CORR,
        payload: res.data
      });
      dispatch(clearErrors());
    }).catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: []
      });
    })

}

export const getSolicitudesCorrectivosCliente = (clienteId) => dispatch => {
  dispatch({ type: LOADING_SOL_CORR });
  apiV1.get(`/getsolicitudesmtocliente/${clienteId}`)
    .then(res => {
      dispatch({
        type: SET_SOL_CORR,
        payload: res.data
      });
      dispatch(clearErrors());
    }).catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: []
      });
    })

}




export const getEquipo = (equipoId) => dispatch => {
  dispatch({ type: LOADING_DATA });
  apiV1.get(`/getequipo/${equipoId}`)
    .then(res => {
      dispatch({
        type: SET_EQUIPO,
        payload: res.data
      });
      dispatch(clearErrors());
    }).catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: []
      });
    })
}


export const getMtoPrev = (mtoId) => dispatch => {
  dispatch({ type: LOADING_DATA });
  console.log('Entre a getMtoPrev')
  apiV2.get(`/getmtopreventivo/${mtoId}`)
    .then(res => {
      dispatch({
        type: SET_MTOPREV,
        payload: res.data
      });
      dispatch(clearErrors());
    }).catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: []
      });
    })
}

export const getMtoPrevV2 = (programacionid) => (dispatch) => {
  dispatch({ type: LOADING_DATA });
  console.log('Entre a getMtoPrev con Programación')
  apiV2.get(`/getmtopreventivoconprog/${programacionid}`)
    .then(res => {
      dispatch({
        type: SET_MTOPREV,
        payload: res.data
      });
      dispatch(clearErrors());
    }).catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: []
      });
    })
};

export const getMtoCorr = (mtoId) => dispatch => {
  dispatch({ type: LOADING_DATA });
  apiV2.get(`/getmtocorrectivov2/${mtoId}`)
    .then(res => {
      dispatch({
        type: SET_MTOPREV,
        payload: res.data
      });
      dispatch(clearErrors());
    }).catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: []
      });
    })
}

export const postDocLegal = (formData, clienteId) => (dispatch) => {
  dispatch({ type: LOADING_UI });

  apiV2
    .post(`/postlegal/${clienteId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then((res) => {
      // Verificar si la respuesta tiene el mensaje 'aprobado'
      dispatch({
        type: SET_OK,
        payload: res.data
      });
      dispatch(clearErrors());
    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response && err.response.data ? err.response.data : { error: 'Error al conectar con el servidor' }
      });
    });
};


export const clearErrors = () => (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
};


export const getDocsLegal = (clienteId) => dispatch => {
  dispatch({ type: LOADING_DATA });
  apiV2.get(`/getlegal/${clienteId}`)
    .then(res => {
      dispatch({
        type: SET_DOCSLEGAL,
        payload: res.data
      });
      dispatch(clearErrors());
    }).catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: []
      });
    })

}

export const deleteDocLegal = (docId) => (dispatch) => {
  dispatch({ type: LOADING_DATA });
  apiV2
    .delete(`/deletedoclegal/${docId}`)
    .then((res) => {
      // Verificar si la respuesta tiene el mensaje 'aprobado'
      dispatch({
        type: SET_OK,
        payload: res.data
      });
      dispatch(clearErrors());
    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response && err.response.data ? err.response.data : { error: 'Error al conectar con el servidor' }
      });
    });
}

export const editDocLegal = (docDetails, clienteId, docId) => (dispatch) => {

  dispatch({ type: LOADING_UI });
  apiV2.post(`/editdoclegal/${docId}`, docDetails)
    .then((res) => {
      // Verificar si la respuesta tiene el mensaje 'aprobado'
      dispatch({
        type: SET_OK,
        payload: res.data
      });
      dispatch(clearErrors());
    })
    .catch((err) => {
      console.error('Error al editar documento:', err);

      // Enviar el error al estado para mostrarlo en UI
      dispatch({
        type: SET_ERRORS,
        payload: err.response ? err.response.data : { error: 'Error al conectar con el servidor' }
      });
    })



};

export const ingenieriaGemini = (dataequipo) => (dispatch) => {
  dispatch({ type: LOADING_UI });
  apiV2.post('/ingenieriaGemini', dataequipo)
    .then((res) => {
      dispatch({
        type: POST_RECOMENDACION_IA,
        payload: res.data
      });
      console.log(res.data);
      dispatch(clearErrors());
    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    })
}

export const limpiezaGemini = (dataequipo) => (dispatch) => {
  dispatch({ type: LOADING_UI });
  apiV2.post('/limpiezaGemini', dataequipo)
    .then((res) => {
      dispatch({
        type: POST_RECOMENDACION_IA,
        payload: res.data
      });
      console.log(res.data);
      dispatch(clearErrors());
    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    })
}

export const usoRecomendacionesGemini = (dataequipo) => (dispatch) => {
  dispatch({ type: LOADING_UI });
  apiV2.post('/usoRecomendacionesGemini', dataequipo)
    .then((res) => {
      dispatch({
        type: POST_RECOMENDACION_IA,
        payload: res.data
      });
      console.log(res.data);
      dispatch(clearErrors());
    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    })
}

export const descripcionGemini = (dataequipo) => (dispatch) => {
  dispatch({ type: LOADING_UI });
  apiV2.post('/descripcionGemini', dataequipo)
    .then((res) => {
      dispatch({
        type: POST_DESCRIPCION_IA,
        payload: res.data
      });
      console.log(res.data);
      dispatch(clearErrors());
    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    })
}

export const asistencialGemini = (dataequipo) => (dispatch) => {
  dispatch({ type: LOADING_UI });
  apiV1.post('/asistencialGemini', dataequipo)
    .then((res) => {
      dispatch({
        type: POST_RECOMENDACION_IA,
        payload: res.data
      });
      dispatch(clearErrors());
    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    })
};

export const getRepuestos = (userHandle) => dispatch => {
  dispatch({ type: LOADING_REPUESTO });
  apiV1.get(`/getRepuestos/${userHandle}`)
    .then(res => {
      dispatch({
        type: SET_REPUESTOS,
        payload: res.data
      });
      dispatch(clearErrors());
    }).catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: []
      });
    })

}

export const postRepuesto = (newRepuesto, handleUser) => dispatch => {
  dispatch({ type: LOADING_UI });
  apiV1
    .post(`/crearRepuesto/${handleUser}`, newRepuesto,)
    .then((res) => {
      dispatch({
        type: SET_OK,
        payload: res.data
      });
      dispatch(clearErrors());




      dispatch(getRepuestos(handleUser));


    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    });

};

export const subirRepuestosExcel = (formData, handleUser) => (dispatch) => {
  dispatch({ type: LOADING_UI });
  apiV1.post(`/subirExcelRepuestos/${handleUser}`, formData)
    .then((res) => {
      dispatch({
        type: SET_OK,
        payload: res.data
      });
      console.log("Se ejecutó y ahora está en el getRepuestos");
    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    });
}

export const subirImagenRepuesto = (formData, repuestoId, handleuser) => (dispatch) => {
  dispatch({ type: LOADING_DATA });

  apiV1.post(`/subirimagenrepuesto/${repuestoId}`, formData)
    .then(() => {
      dispatch(getRepuestos(handleuser));
    })
    .catch(err => console.log(err));
};

export const deleteRepuesto = (repuestoid) => (dispatch) => {
  dispatch({ type: LOADING_UI });

  apiV1
    .post(`/deleteRepuesto/${repuestoid}`)
    .then((res) => {
      dispatch({
        type: SET_OK,
        payload: res.data
      });


    })
    .catch((err) => console.log(err));
}

export const editRepuesto = (newRepuesto, repuestoId, handleUser) => dispatch => {
  dispatch({ type: LOADING_UI });
  apiV1
    .post(`/editRepuesto/${repuestoId}`, newRepuesto)
    .then((res) => {
      dispatch({
        type: SET_OK,
        payload: res.data
      });
      dispatch(clearErrors());


    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    });

};


export const createCasoTecno = (dataReporte, clienteId, equipoId) => dispatch => {
  dispatch({ type: LOADING_UI });
  console.log(dataReporte, clienteId, equipoId)
  apiV2.post(`/crearCasoTecno/${clienteId}/${equipoId}`, dataReporte)
    .then(res => {
      dispatch({
        type: SET_OK,
        payload: res.data
      });
      dispatch(clearErrors());
    }).catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
      console.log(err.response.data)
    })
}

export const editCasoTecno = (dataReporte, idReporte) => dispatch => {
  dispatch({ type: LOADING_UI });
  console.log(dataReporte, idReporte)
  apiV2.post(`/editarCasoTecno/${idReporte}`, dataReporte)
    .then(res => {
      dispatch({
        type: SET_OK,
        payload: res.data
      });
      dispatch(clearErrors());
    }).catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
      console.log(err.response.data)
    })
}

export const getCasosTecnoCliente = (clienteId, fechaInicio, fechaFin) => dispatch => {
  dispatch({ type: LOADING_UI });
  apiV2.get(`/getCasosTecnoTotal/${clienteId}`, {
    params: {
      fechaInicio: fechaInicio,
      fechaFin: fechaFin
    }
  })
    .then(res => {
      dispatch({
        type: SET_CASOS_TECNO,
        payload: res.data
      });
      dispatch(clearErrors());
    }).catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
      console.log(err.response.data)
    })
}

export const getCasosTecnoEquipo = (equipoId) => dispatch => {
  dispatch({ type: LOADING_UI });
  apiV2.get(`/getCasosTecnoEquipo/${equipoId}`)
    .then(res => {
      dispatch({
        type: SET_CASOS_TECNO,
        payload: res.data
      });
      dispatch(clearErrors());
    }).catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
      console.log(err.response.data)
    })
}

export const getCasoTecno = (docId, clienteId) => dispatch => {
  dispatch({ type: LOADING_UI });
  apiV2.get(`/getCasoTecno/${clienteId}/${docId}`)
    .then(res => {
      dispatch({
        type: SET_CASO_TECNO,
        payload: res.data
      });
      dispatch(clearErrors());
    }).catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
      console.log(err.response.data)
    })
}




export const deleteCasoTecno = (docId, equipoId) => dispatch => {
  dispatch({ type: LOADING_UI });
  apiV2.delete(`/eliminarCasoTecno/${docId}`)
    .then((res) => {
      dispatch({
        type: SET_OK,
        payload: res.data
      });

    })
    .catch((err) => {
      console.log('Error al eliminar el usuario');
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      })
    });
}


export const getTotalCursos = () => (dispatch) => {
  dispatch({ type: LOADING_UI })
  apiV1.get('/getcursos')
    .then((res) => {
      dispatch({
        type: GET_CURSOS,
        payload: res.data
      })
    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      })
      console.log("Ocurrió un error")
    })
}

export const getCursosRecomendados = (userHandle) => (dispatch) => {
  dispatch({ type: LOADING_UI })
  apiV1.get(`/getCursosRecomendados/${userHandle}`)
    .then((res) => {
      dispatch({
        type: GET_CURSOS_RECOMENDADOS,
        payload: res.data
      })
      dispatch(clearErrors());
    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      })
      console.log("Ocurrió un error")
    })
}

export const postRutaDeAprendizaje = (preferencias) => (dispatch) => {
  dispatch({ type: LOADING_DATA_UI })
  apiV1.post(`/rutaDeAprendizaje`, preferencias)
    .then((res) => {
      dispatch({
        type: POST_RUTA_APRENDIZAJE,
        payload: res.data
      })
      dispatch({ type: STOP_LOADING_DATA })
      dispatch(clearErrors());
      console.log(res.data)
    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS_DATA,
        payload: err.response.data
      })
      console.log("Ocurrió un error")
    })
}

export const guardarRutaCursos = (nuevaruta) => (dispatch) => {
  dispatch({ type: LOADING_DATA_UI })

  apiV1.post(`/addCursosRecomendados`, nuevaruta)
    .then((res) => {
      dispatch({
        type: SET_OK_DATA,
        payload: res.data
      });

    })
    .catch((err) => {
      console.log('Error al guardar ruta');
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      })
    });

}

export const getTareasClienteFiltrado = (clienteId, fechaInicio, fechaFin) => dispatch => {

  apiV1.get(`/gettareascliente/${clienteId}`, {
    params: {
      fechaInicio: fechaInicio,
      fechaFin: fechaFin
    }
  })
    .then(res => {
      dispatch({
        type: SET_TAREAS_CLIENTE,
        payload: res.data
      });
      dispatch(clearErrors());
    }).catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
      console.log(err.response.data)
    })
}

export const postTareaCliente = (dataTarea, clienteId) => dispatch => {
  dispatch({ type: LOADING_UI });

  apiV1.post(`/creartareacliente/${clienteId}`, dataTarea)
    .then(res => {
      dispatch({
        type: SET_OK,
        payload: res.data
      });
      dispatch(clearErrors());
    }).catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
      console.log(err.response.data)
    })
}

export const postAprobarTarea = (tareaid) => (dispatch) => {
  dispatch({ type: LOADING_UI })

  apiV1.post(`/aprobartarea/${tareaid}`)
    .then((res) => {
      dispatch({
        type: SET_OK,
        payload: res.data
      });

    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    });
}

export const deleteTarea = (tareaId) => dispatch => {
  dispatch({ type: LOADING_UI });
  apiV1.delete(`/deletetarea/${tareaId}`)
    .then((res) => {
      dispatch({
        type: SET_OK,
        payload: res.data
      });

    })
    .catch((err) => {
      console.log('Error al eliminar esta tarea');
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      })
    });
}

export const editTarea = (newTarea, tareaId) => dispatch => {
  dispatch({ type: LOADING_UI });
  apiV1
    .post(`/edittareacliente/${tareaId}`, newTarea,)
    .then((res) => {
      dispatch({
        type: SET_OK,
        payload: res.data
      });
      dispatch(clearErrors());




    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    });

};

export const getIndicadoresNew = (handleuser) => dispatch => {

  apiV2.get(`/getIndicadores/${handleuser}`)
    .then(res => {
      dispatch({
        type: SET_INDICADORES_NEW,
        payload: res.data
      });
      dispatch(clearErrors());
    }).catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
      console.log(err.response.data)
    })
}

export const getAnalisisObsolescenciaUsuario = (userHandle, En_Mto, De_Baja, Corr, Sol, Mas_viejos, vida, tecno, umbral) => (dispatch) => {
  dispatch({ type: LOADING_DATA_UI })
  apiV1.get(`/datosAnalisisDeObsolescenciaUsuario/${userHandle}`, {
    params: {
      En_Mantenimiento: En_Mto,
      De_Baja: De_Baja,
      Correctivos: Corr,
      Solicitudes: Sol,
      Mas_viejos: Mas_viejos,
      vida: vida,
      casos_tecnovigilancia: tecno,
      umbral: umbral,
    }
  })
    .then((res) => {
      //console.log(res.data)
      dispatch({
        type: GET_ANALISIS_OBSOLESCENCIA_USUARIO,
        payload: res.data
      })
      dispatch(clearErrors());
      dispatch({ type: STOP_LOADING_DATA })
    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS_DATA,
        payload: err.response.data
      })
      console.log("Ocurrió un error")
    })
}

export const getAnalisisObsolescenciaPrestador = (clienteId, En_Mto, De_Baja, Corr, Sol, Mas_viejos, vida, tecno, umbral) => (dispatch) => {
  dispatch({ type: LOADING_DATA_UI })
  apiV1.get(`/datosAnalisisDeObsolescenciaPrestador/${clienteId}`, {
    params: {
      En_Mantenimiento: En_Mto,
      De_Baja: De_Baja,
      Correctivos: Corr,
      Solicitudes: Sol,
      Mas_viejos: Mas_viejos,
      vida: vida,
      casos_tecnovigilancia: tecno,
      umbral: umbral,
    }
  })
    .then((res) => {
      //console.log(res.data)
      dispatch({
        type: GET_ANALISIS_OBSOLESCENCIA_PRESTADOR,
        payload: res.data
      })
      dispatch(clearErrors());
      dispatch({ type: STOP_LOADING_DATA })
    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS_DATA,
        payload: err.response.data
      })
      console.log("Ocurrió un error")
    })
}

export const postAnalisisPrestador = (data) => (dispatch) => {
  dispatch({ type: LOADING_DATA_UI })
  apiV1.post(`/postAnalisisDeObsolescencia`, data)
    .then((res) => {
      dispatch(clearErrors());
      //console.log(res.data)

      dispatch({
        type: SET_OK,
        payload: res.data
      });
      dispatch({ type: STOP_LOADING_DATA })

      console.log("Se ejecutó y ahora está en el getCliente");
    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    });
}

export const solicitudInformacion = (newData) => dispatch => {
  dispatch({ type: LOADING_UI });
  apiV2
    .post('/solicitudinformacion', newData)
    .then((res) => {
      dispatch({
        type: SET_OK,
        payload: res.data,
      });
      dispatch(clearErrors());


    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    });

};

export const solicitudReunion = (newData) => dispatch => {
  dispatch({ type: LOADING_UI });
  apiV2
    .post('/solicitudreunion', newData)
    .then((res) => {
      dispatch({
        type: SET_OK,
        payload: res.data,
      });
      dispatch(clearErrors());


    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    });

};

